
/* System defined core library */
import { Component, EventEmitter, Input, Output, HostListener, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { CaptchaComponent } from '../../../../shared/components/captcha/captcha.component';

/* User defined library/components */
import { BootstrapParams } from '../../../../../bootstrap-params';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';
import { UtilityService } from '../../../../shared/services/utility.service';

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Country } from '../../../../shared/models/scheduling/country.model';
import { DatepickerDate } from '../../../../shared/models/common/date.model';
import { EligibilityDetail } from '../../../../shared/models/scheduling/eligibility.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { LocationSelector } from '../../../../shared/models/scheduling/locationSelector.model';
import { MetricDetails } from '../../../../shared/models/scheduling/metrics.model';
import { Program } from '../../../../shared/models/scheduling/program.model';
import { State } from '../../../../shared/models/scheduling/state.model';

/* User defined enums/constants */
import { ComponentType, MetricType } from '../../../../shared/enums/scheduling.enum';
import { TargetFlow } from '../../../../shared/constants/scheduling.constant';

@Component({
  selector: 'app-location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss'],
})
export class LocationSelectorComponent {

  // need a better approach to handle this - MM
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (!this.isCurrentFormChanged) {
      this.selectedExamDetailService.setSelectedLocation(null);
    }
    if (!this.isBackToBackRequired && this.targetFlow !== TargetFlow.FindAvailability) {
      let seatval: LocationSelector = { region: this.region, selectedStartDate: this.selectedStartDate, selectedEndDate: this.selectedEndDate };
      this.selectedExamDetailService.setSelectedLocation(seatval);
      if (this.selectedIndex === 1) {
        this.examName = this.selectedAppointments[this.selectedIndex - 1].exam.name;
      }
      this.selectedIndex -= 1;
      this.selectedExamDetailService.selectedAppointmentIndex = this.selectedIndex;
      this.selectedExamDetailService.appointmentCountForInfo.next(this.selectedExamDetailService.selectedAppointmentIndex);

      if (this.selectedExamDetailService.selectedAppointmentIndex > -1) {

        this.selectedAppointments[this.selectedIndex].region = (this.region != null && this.region != undefined) ?
          this.region : this.selectedAppointments[this.selectedIndex].region;

        this.selectedAppointments[this.selectedIndex].selectedStartDate = (this.selectedStartDate != null && this.selectedStartDate != undefined) ?
          this.selectedStartDate : this.selectedAppointments[this.selectedIndex].selectedStartDate;

        this.selectedAppointments[this.selectedIndex].selectedEndDate = (this.selectedEndDate != null && this.selectedEndDate != undefined) ?
          this.selectedEndDate : this.selectedAppointments[this.selectedIndex].selectedEndDate;

        this.selectedExamDetailService.setSelectedStartDate(this.selectedAppointments[this.selectedIndex].selectedStartDate);
        this.selectedExamDetailService.setSelectedEndDate(this.selectedAppointments[this.selectedIndex].selectedEndDate);

        this.selectedExamDetailService.setSlot(null);// Set previous slot NULL.
        this.selectedExamDetailService.setHold(null);// Set previous Hold NULL.

        if (this.targetFlow == "Reschedule") {
          this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointments);
          this.selectedExamDetailService.setSlot(null);
          this.selectedExamDetailService.setSiteSlot(null);
        }
      }
    }
    else {
      let seatval: LocationSelector = { region: this.region, selectedStartDate: this.selectedStartDate, selectedEndDate: this.selectedEndDate };
      this.selectedExamDetailService.setSelectedLocation(seatval);
    }
  }

  public locationDataSource: Observable<any>;
  public region: State;
  public selectedLocation: any;
  public zoom: number = 1;
  public defaultCalendarMonth: string;
  public selectedStartDate: any;
  public selectedEndDate: any;
  public selectedSeat: any;
  public formattedAddress: string;
  public isCurrentFormChanged: Boolean;
  public showSelectedDate: boolean = false;
  public isLocationSelected: boolean = false;
  public toggleCalendar: boolean = false;
  public startDateError: string = '';
  public endDateError: string = '';
  public selectedAppointments: AppointmentDetail[] = []
  public client: Client;
  public exam: Exam;
  public program: Program;
  public selectedIndex: number = 0;
  public endDisabled: boolean = true;
  public examName: string;
  public isBackToBackRequired: boolean = false;
  public metricDetails: MetricDetails;
  public firstTimeSearch: boolean;
  public selectedCountry: Country;
  public selectedState: State;
  public isRegionSelectorValid: boolean = false;
  public isGoogleMapsValid: boolean = true;
  public startDateInput: ElementRef;
  public typeaheadNoResults: boolean;
  public voucherExpDate: string;
  public captchaEnable: boolean;
  public overlapsDate: string;
  public eligibility: EligibilityDetail[];

  public today = new Date();

  public startDateOptions: kendo.ui.DatePickerOptions;

  public endDateOptions: kendo.ui.DatePickerOptions;

  public placeHolderText: string;

  /* Input-OutPut parameters decalartions */
  @Input() geolocation: any[];
  @Output() setPlaceHolder = new EventEmitter<any>();
  @Output() selectionMode = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();
  @Output() location = new EventEmitter<any>();
  @Output() validRegionSelector = new EventEmitter<any>();
  @Input() geolocationChange: any[];
  @Input() SelectedStartDate: any;
  @Input() SelectedEndDate: any;
  @Input() targetFlow: string;

  /* Service subscriptions */
  region$: Subscription;
  selectedLocation$: Subscription;
  defaultCalendarMonth$: Subscription;
  selectedStartDate$: Subscription;
  selectedEndDate$: Subscription;
  selectedAppointments$: Subscription;
  client$: Subscription;
  program$: Subscription;
  exam$: Subscription;
  metricDetails$: Subscription;
  firstTimeSearch$: Subscription;
  eligibility$: Subscription;

  overlapsDate$: Subscription;
  overLapStartDate: any;
  overLapStartDate$: Subscription;
  overLapEndDate: any;
  overLapEndDate$: Subscription;
  country$: Subscription;
  state$: Subscription;
  translateLanguage$: Subscription;
  voucherExpDate$: Subscription;

  @ViewChild(CaptchaComponent) captchaInstance: CaptchaComponent;

  /* Constructor declaration with required injected services */
  public constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private utilityService: UtilityService,
    private translate: TranslateService,
    private bootstrapParams: BootstrapParams
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.region$ = selectedExamDetailService.region.subscribe(region => {
      this.region = region;
    });

    this.selectedLocation$ = selectedExamDetailService.locationSelector.subscribe(selectedLocation => {
      this.selectedSeat = selectedLocation;
    });

    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });

    this.program$ = selectedExamDetailService.program.subscribe(program => {
      this.program = program;
    });

    this.selectedAppointments$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      selectedAppointments => {
        this.selectedAppointments = selectedAppointments;
      });

    this.exam$ = selectedExamDetailService.exam.subscribe(exam => {
      this.exam = exam;
      if (exam == null || exam == undefined) {
        this.exam = (this.selectedAppointments && this.selectedAppointments.length) ? this.selectedAppointments[0].exam : null;
      }
    });

    this.eligibility$ = selectedExamDetailService.eligibilityDetails.subscribe(
      eligibility => {
        this.eligibility = eligibility;
      });

    this.overlapsDate$ = selectedExamDetailService.overlapsDate.subscribe(
      overlapsDate => {
        this.overlapsDate = overlapsDate;
      });

    this.overLapStartDate$ = selectedExamDetailService.overlapsFromDate.subscribe(
      startDate => {
        this.overLapStartDate = startDate;
      });

    this.overLapEndDate$ = selectedExamDetailService.overlapsToDate.subscribe(
      endDate => {
        this.overLapEndDate = endDate;
      });

    this.metricDetails$ = selectedExamDetailService.metricDetails.subscribe(metricDetails => {
      this.metricDetails = metricDetails;
    });


    this.country$ = selectedExamDetailService.lpiCountry.subscribe(country => {
      this.selectedCountry = country;
    });

    this.state$ = selectedExamDetailService.lpiState.subscribe(state => {
      this.selectedState = state;
    });

    this.locationDataSource = new Observable((observer: any) => {
      observer.next(this.geolocation);
    })
      .pipe(mergeMap((token: string) => this.getLocation(token)));

    if (this.selectedSeat != undefined && this.selectedSeat != null) {
      this.formattedAddress = this.selectedSeat.region ? this.selectedSeat.region.name : 'locationSelectorComponent.placeholderText';
      this.selectedStartDate = this.selectedSeat.selectedStartDate;
      this.setPlaceHolder.emit(this.formattedAddress);
    }
    else if (this.region != null) {
      this.formattedAddress = this.region.name;
      this.setPlaceHolder.emit(this.formattedAddress);
    }
    else {
      this.formattedAddress = "locationSelectorComponent.placeholderText";
      this.setPlaceHolder.emit(this.formattedAddress);
    }

    this.defaultCalendarMonth$ = selectedExamDetailService.defaultCalendarMonth.subscribe(defaultCalendarMonth => {
      this.defaultCalendarMonth = defaultCalendarMonth;
    });

    this.selectedStartDate$ = selectedExamDetailService.selectedStartDate.subscribe(selectedStartDate => {
      this.selectedStartDate = selectedStartDate;
    });

    this.selectedEndDate$ = selectedExamDetailService.selectedEndDate.subscribe(selectedEndDate => {
      this.selectedEndDate = selectedEndDate;
    });

    this.voucherExpDate$ = this.selectedExamDetailService.voucherExpDate.subscribe(voucherExpDate => {
      this.voucherExpDate = voucherExpDate;
    });

    this.selectedIndex = this.selectedExamDetailService.selectedAppointmentIndex;
    this.isBackToBackRequired = this.selectedExamDetailService.isBackToBackRequired;

    if (this.targetFlow == null || this.targetFlow == undefined)
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;

    if (this.selectedStartDate != null || this.selectedStartDate != undefined) {
      this.selectedExamDetailService.setSelectedStartDate(this.selectedStartDate);
      this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
    }

    this.firstTimeSearch$ = this.selectedExamDetailService.firstTimeSearch.subscribe(firstTimeSearch => {
      this.firstTimeSearch = firstTimeSearch;
    });

    this.isGoogleMapsValid = this.selectedExamDetailService.isGoogleMapsValid;
    this.placeHolderText = this.selectedExamDetailService.dateFormat.toUpperCase();
    this.captchaEnable = this.bootstrapParams.captchaEnable;

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      start: "month"
    };
  }

  ngOnInit(): void {
    this.isCurrentFormChanged = false;
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.LocationSelectorComponent)) return;

    if (!this.selectedStartDate) this.endDisabled = true;
    if (this.selectedIndex > -1) { this.examName = this.selectedAppointments[this.selectedIndex].exam.name; }

    if (this.selectedAppointments == null || this.selectedAppointments == undefined) {
      this.selectedAppointments = [];
      let tmpAppointmentDetail: AppointmentDetail = new AppointmentDetail();
      tmpAppointmentDetail.client = this.client;
      tmpAppointmentDetail.program = this.program;
      tmpAppointmentDetail.exam = this.exam;
      this.selectedAppointments.push(tmpAppointmentDetail);
      this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointments);
    }

    if (this.region != null && this.region != undefined) {
      this.isLocationSelected = true;
    }
    if (this.selectedStartDate != null || this.selectedStartDate != undefined) {
      this.setSelectedStartDate(this.selectedStartDate);
    }
    if (this.SelectedEndDate != null || this.SelectedEndDate != undefined) {
      this.setSelectedEndDate(this.SelectedEndDate);
    }

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    if (this.selectedStartDate) {
      this.endDateOptions = {
        format: this.selectedExamDetailService.dateFormat,
        culture: this.selectedExamDetailService.browserCulture,
        min: this.getValidEndDateStart(),
        max: this.getValidEndDateEnd(),
        start: "month",
        disableDates: [this.today]
      };
    }

    if (!this.isGoogleMapsValid) {
      this.validateRegionSelector();
    }

    // pre-populate the start and end dates in datepicker based on overlap dates on eligbility and voucher
    if (!this.selectedStartDate && !!this.overLapStartDate && !!this.overLapEndDate) {
      var overlapRange = this.utilityService.getValidEligibilityDates(this.overLapStartDate, this.overLapEndDate);
      if (!!overlapRange) {
        this.setSelectedStartDate(overlapRange[0]);
        this.setSelectedEndDate(overlapRange[1]);
      }
    }

    let defaultMonth = this.utilityService.getEligibleMonth(this.overLapStartDate);
    this.selectedExamDetailService.setDefaultCalendarMonth(defaultMonth);
  }

  public validateCaptcha() {
    this.captchaInstance.validateCaptcha();
  }

  setStartDateInput(event: ElementRef) {
    this.startDateInput = event;
  }

  public getLocation(token: string): Observable<any> {
    return of(token);
  }

  /* Set Start date in shaered service */
  setSelectedStartDate(value: any): void {
    const today = new Date();
    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();

    var currentDate = new Date(year, month - 1, day);
    currentDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0);
    if (currentDate && currentDate < today) this.startDateError = "Start date must be a date in the future.";
    else if (currentDate && currentDate >= today) {
      this.startDateError = '';
      this.toggleCalendar = true;
      this.selectionMode.emit('end');
      this.selectedStartDate = value;
      this.selectedExamDetailService.setSelectedStartDate(this.selectedStartDate);
      this.endDisabled = false;
      if (!this.selectedEndDate) {
        this.endDateError = '';
        this.selectedEndDate = new DatepickerDate(null, this.getValidEndDateStart());
        this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
      }
      if (this.selectedEndDate) {
        const start = new Date(value['date']['year'], value['date']['month'] - 1, value['date']['day']);
        const end = new Date(this.selectedEndDate['date']['year'],
          this.selectedEndDate['date']['month'] - 1,
          this.selectedEndDate['date']['day']);
        const endLimit = new Date(start);
        endLimit.setDate(start.getDate() + 14);

        endLimit.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (end > endLimit || end < start) {
          this.endDateError = '';
          this.selectedEndDate = new DatepickerDate(null, this.getValidEndDateStart());
          this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
        }
      }
    }
    this.error.emit({ endDateError: this.endDateError, startDateError: this.startDateError, typeaheadNoResults: this.typeaheadNoResults });

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidEndDateStart(),
      max: this.getValidEndDateEnd(),
      start: "month",
      disableDates: [this.today]
    };
  }

  /* Set End date in shared service */
  setSelectedEndDate(value: any): void {
    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();
    var currentDate = new Date(year, month - 1, day);

    const selectedStartDate =
      new Date(this.selectedStartDate['date']['year'], this.selectedStartDate['date']['month'] - 1, this.selectedStartDate['date']['day'])

    const endLimit = new Date(selectedStartDate);
    endLimit.setDate(selectedStartDate.getDate() + 15);

    endLimit.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0);
    selectedStartDate.setHours(0, 0, 0, 0);
    if (!currentDate)
      this.endDateError = 'You must select an end date that is within 2 weeks of the selected start date.';

    if (currentDate && (currentDate > endLimit || currentDate < this.getValidEndDateStart()))
      this.endDateError = "You must select an end date that is within 2 weeks of the selected start date.";

    else if (currentDate && currentDate < endLimit && currentDate >= this.getValidEndDateStart()) {
      this.endDateError = '';
      this.toggleCalendar = false;
      this.selectionMode.emit('start');
      this.selectedEndDate = value;
      this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
    }
    this.error.emit({ endDateError: this.endDateError, startDateError: this.startDateError, typeaheadNoResults: this.typeaheadNoResults });
  }

  errorTextEvent(event: any): void {
    this.typeaheadNoResults = event[0].typeaheadNoResults;
    this.error.emit({ endDateError: this.endDateError, startDateError: this.startDateError, typeaheadNoResults: this.typeaheadNoResults });
  }

  /* Set Selected Country*/
  setSelectedCountry(country: Country) {
    this.selectedCountry = country;
    this.selectedExamDetailService.setLpiCountry(this.selectedCountry);
    this.selectedState = null;
    this.validateRegionSelector();
  }

  /* Set Selected Region*/
  setSelectedRegion(state: State) {
    this.selectedState = state;
    if (state && state.id != "-1") {
      this.selectedExamDetailService.setLpiState(this.selectedState);
    }
    this.validateRegionSelector();
  }

  /* Validate Region selector is valid or not */
  validateRegionSelector() {
    if (this.selectedCountry == null || this.selectedCountry == undefined) {
      this.isRegionSelectorValid = false;
    }
    else if ((this.selectedCountry != null || this.selectedCountry != undefined) &&
      (this.selectedState != null && this.selectedState != undefined && this.selectedState.id == "-1")) {
      this.isRegionSelectorValid = true;
    }
    else if ((this.selectedCountry != null || this.selectedCountry != undefined) &&
      (this.selectedState != null && this.selectedState != undefined && this.selectedState.id != "-1")) {
      this.isRegionSelectorValid = true;
    }
    else {
      this.isRegionSelectorValid = false;
    }
    this.validRegionSelector.emit(this.isRegionSelectorValid);
  }

  /* Get geo location and set region based on that */
  getGeoLocation(event: any, value: any): void {
    this.isLocationSelected = true;
    let stateVal: State = value ? { id: '', lat: value[0], long: value[1], uri: '', name: value[2] } : null;
    this.region = stateVal;
    this.selectedExamDetailService.setRegion(this.region);
    this.isCurrentFormChanged = true;
    this.location.emit({ isLocationSelected: this.isLocationSelected, isCurrentFormChanged: this.isCurrentFormChanged });
    if (!!this.startDateInput) {
      this.startDateInput.nativeElement.focus();
    }
  }

  // TODO: Move these date functions to service - MM
  getValidStart(): Date {
    return this.utilityService.getValidStart(this.overLapStartDate);
  }

  getValidStartDateEnd(): Date {
    return this.utilityService.getValidStartDateEnd(this.overLapStartDate, this.overLapEndDate);
  }

  getValidEndDateEnd(): Date {
    return this.utilityService.getValidEndDateEnd(this.selectedStartDate['date'], this.overLapEndDate, this.bootstrapParams.defaultSearchDateRange);
  }

  getValidEndDateStart(): Date {
    const beginDate = this.selectedStartDate['date'];
    return this.utilityService.getValidEndDateStart(beginDate, (!!this.exam.sessions && this.exam.sessions.length > 1) ? this.exam.sessions.length - 1 : 0);
  }

  /* Only display testing window if an eligibility was used or if it ends within a relevant amount of time */
  displayTestingWindow(): boolean {
    const toDate = new Date(this.overLapEndDate);
    return (!!this.eligibility
      && !!this.eligibility.length
      && !!this.eligibility[0]
      && !!this.eligibility[0].id)
      || (toDate.getFullYear() <= this.today.getFullYear() + this.bootstrapParams.testingWindowDisplayYears);
  }
}
